export default __webpack_public_path__ + "static/media/express.cca64e0f.png";